import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { TaasTkvV2Data } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { TkvActions } from '../tkvActions';
import { IAppState } from '../appState';
import { buildTaasTkvV2DataForStrecke } from './transformer/tkvData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasTkvV2Data>;

export function* streckenTarifierungTkv(): Generator<ForkEffect> {
  const requestActions = [
    TARIF_CHECKED,
    ZUSATZOPTION_CHECKED,
    ZUSATZOPTION_UNCHECKED,
    TkvActions.PREISE_REQUESTED,
    TkvActions.SELBSTBETEILIGUNG_CHANGED,
    TkvActions.HEILBEHANDLUNGSSCHUTZ_CHANGED,
  ];
  const successActions = [
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_TKV_V2,
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_TKV_V2,
  ];

  streckenTarifierer = new StreckenTarifierer(
    {
      appId: App.TKV_V2,
      successEventWithInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_TKV_V2,
      successEventWithoutInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_TKV_V2,
      errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_TKV_V2,
    },
    buildTaasTkvV2DataForStrecke,
    undefined,
    createHashedRelevantRiskdataTKV,
  );

  yield takeEvery(successActions, safeSaga(streckenTarifierer.handleSuccess, App.TKV_V2));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_TKV_V2,
    safeSaga(streckenTarifierer.handleError, App.TKV_V2),
  );
  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.TKV_V2));
}

export function createHashedRelevantRiskdataTKV(taasData: TaasTkvV2Data): string {
  const relevantData = { ...taasData };
  delete relevantData.salesProducts;
  delete relevantData.spartenType;
  delete relevantData.sublimit;

  return createHashedTaasData(relevantData);
}
